import { EMBEDDED_URL_PROPERTY_NAME, URL_PROPERTY_NAME } from './constants';
import getExtendedPropertyFromItem from './getExtendedPropertyFromItem';
import { ClientItem } from 'owa-mail-store';

export default function hasUrlExtendedProperties(item: ClientItem): boolean {
    return (
        !!getExtendedPropertyFromItem(item, EMBEDDED_URL_PROPERTY_NAME) ||
        !!getExtendedPropertyFromItem(item, URL_PROPERTY_NAME)
    );
}
